(function(){
    
    $('#btnSave').click(function(e){
        e.preventDefault();
        $('#newClassroomLogForm').submit();
    });

    var alertTestUnavailable = function () {
        sweetAlert("I test saranno disponibili da gennaio 2016");
    };

    /*
    |--------------------------------------------------------------------------
    | ENTRY FORM
    |--------------------------------------------------------------------------
    */

    $("#submitFormBtn").click( function(e) {
    	e.preventDefault();
		var comment = $('textarea[name=comment]').val();
		if ( 0 === comment.length) {
			sweetAlert("Per favore, inserire un commento.", "", "error");
		} else {
			$('#entryFrom').submit();
		}
	});

    $('.disabledTest').click( function(e) {
        e.preventDefault();
        alertTestUnavailable();
    });


	/*
	|--------------------------------------------------------------------------
	| DIARY & EXAMS
	|--------------------------------------------------------------------------
	*/
    $('.uploadLink').click(function(){

        if( $(this).data('type') == "Documents" || $(this).data('type') == "Archives") {
            openInNewTab($(this).data('course'), $(this).data('lesson'), $(this).data('slug'));
            return true;
        }

        loadContent($(this).data('course'), $(this).data('lesson'), $(this).data('slug'));
    });

    var openInNewTab = function(course, lesson, slug) {
        var url = "/courses/" + course + "/" + lesson + "/" + slug;
        var win = window.open(url, '_blank');
        win.focus();
    };

    var performAjaxRequest = function(url, options, callback)
    {
        $.ajax({
            url: url,
            data: options,
            type: "POST",
            dataType: "html",
            success: function (data) {
                callback(data);
            },
            error: function (xhr, status) {
                alertAjaxError();
            }
        });
    };

    var loadContent = function (course, lesson, slug) {
        var options = {};
        options._token = _csrf;
        var url = "/courses/" + course + "/" + lesson + "/" + slug;
        performAjaxRequest(url, options, displayContent);

        var uploadTitleUrl = "/courses/" + course + "/" + lesson + "/" + slug + "/title";
        performAjaxRequest(uploadTitleUrl, options, displayUploadTitle);
    };

    var displayContent = function (data){
        $('#lessonContent').html(data);
        videojs(document.getElementsByClassName("video-js")[0], {}, function(){
          resizeVideoJS();
        });

    };

  var displayUploadTitle = function (data){
    $('#uploadTitleContainer').html(data);
  };

    var alertAjaxError = function () {
        sweetAlert("Si è verificato un problema durante il caricamento del materiale.\nProva a ricaricare la pagina!", "", "error");
    };

    /*
    |--------------------------------------------------------------------------
    | VIDEO JS
    |--------------------------------------------------------------------------
    */
    var aspectRatio = 9/16; // Make up an aspect ratio
    function resizeVideoJS(){
        $(".video-js").each(function(index) {
            var width = $(this).parent().width();
            console.log(width);
            $(this).width(width).height( width * aspectRatio );
        });
    }
    resizeVideoJS(); // Initialize the function

})();
